module.exports = __webpack_public_path__ + "assets/websocket_2_24.png";